// Mock data for Paul Vilas Music Producer Landing Page

export const BRAND = {
  name: "Paul Vilas",
  email: "contact@paulvilas.com",
  domain: "paulvilas.com",
  url: "https://paulvilas.com",
  tagline: "You deserve better songs.",
  hero: {
    title: "Stop Sitting On",
    accent: "Great",
    suffix: "Songs",
    subtitle:
      "I'll help you finish them, produce them, and release them with confidence.",
    cta: "Start Here",
    bg: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtdXNpYyUyMHN0dWRpb3xlbnwwfHx8fDE3ODA0MDYzMzV8MA&ixlib=rb-4.1.0&q=85",
  },
};

export const FEATURED_LOGOS = [
  { name: "billboard", style: "font-serif italic" },
  { name: "NYLON", style: "font-bold tracking-widest" },
  { name: "SPIN", style: "font-black" },
  { name: "AP", style: "font-black tracking-tight" },
];

export const SERVICES = {
  heading: "What I Do.",
  title: "Full service",
  items: [
    "Direction",
    "Arrangement",
    "Lyrics + Melody",
    "Instrumentation",
    "Mixing/Mastering",
    "From anywhere",
  ],
  pillars: [
    {
      title: "Where We Start",
      body: "We figure out the vibe, what you want the song to feel like and how to make it actually hit.",
    },
    {
      title: "Make The Hard Part Easy",
      body: "I comb through ideas w/ you to make sure we pick out the best of the best \u201chidden gems\u201d you might have missed.",
    },
    {
      title: "Bring The Ideas To Life",
      body: "I always get feedback along the way. I send you creative ideas quickly so we can get to shaping the song exactly where you want it to go.",
    },
  ],
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Eli",
    avatar: "https://i.pravatar.cc/100?img=12",
    message:
      "1st time we've ever hit 100K monthly listeners. Don't even know what to say man",
    response: "\u2764\ufe0f",
    time: "Active 2h Ago",
  },
  {
    id: 2,
    name: "Milo H.",
    avatar: "https://i.pravatar.cc/100?img=33",
    message:
      "2 indie labels hit me up after the new song dropped. They want us to do an EP!!",
    response: "What a message to wake up to!",
    time: "Active 1h Ago",
  },
  {
    id: 3,
    name: "Nico P.",
    avatar: "https://i.pravatar.cc/100?img=68",
    message:
      "Last time we played this venue was like 50 people lol. Tonight 275 paid!",
    response: "Dude wtf for real?!",
    time: "Active 5h Ago",
  },
  {
    id: 4,
    name: "Lily R.",
    avatar: "https://i.pravatar.cc/100?img=47",
    message:
      "dude. It's WILD to see $1200 show up in my account from Apple and Spotify",
    response: "Let's keep going!",
    time: "Active 3h Ago",
  },
  {
    id: 5,
    name: "Sam C.",
    avatar: "https://i.pravatar.cc/100?img=15",
    message:
      "2 more placements. Hulu and HBO max for \u201cyou said it\u201d let's GOOOOO!",
    response: "Huge!! \ud83d\udd25",
    time: "Active 6h Ago",
  },
  {
    id: 6,
    name: "Avery K.",
    avatar: "https://i.pravatar.cc/100?img=23",
    message:
      "the new mix hits SO different in the car. I've literally listened 40 times today",
    response: "That's the goal \ud83d\ude4c",
    time: "Active 30m Ago",
  },
];

export const CATALOG = {
  heading: "The Catalog.",
  featured: "PAUL music",
  covers: [
    "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/8btq2q54_Screenshot%202026-06-02%20at%2013.41.22.png",
    "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/jbf8o2da_Screenshot%202026-06-02%20at%2013.42.14.png",
    "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/3npmsksk_Screenshot%202026-06-02%20at%2013.43.35.png",
    "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/kbtscl9k_Screenshot%202026-06-02%20at%2013.44.37.png",
  ],
  spotifyLink: "#",
};

export const ABOUT = {
  heading: "You deserve better songs.",
  sub: "I've spent the last decade helping artists turn unfinished ideas into records they're proud to release.",
  photo: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/w0fnwpzi_IMG_6232%20copy.jpg",
  bullets: [
    "What recording program is best?",
    "What Mic should I get?",
    "What plug-ins do I need?",
    "Why don't my vocals sound like big artists do?",
    "What instruments do I need?",
    "How do I mix and master this sh*t?",
    "How do I structure a song to keep peoples attention?",
    "How do I organize lyrics?",
    "How do I promote my music without feeling cringey",
    "Etc. Etc. Etc…",
  ],
  intro: "When I started, I sort of had to figure everything out on my own -",
  closing: "Good news, you don't need to spend a decade trying to figure all that out.",
  closingSub: "You show up, have fun and we bring the whole thing to life.",
};

export const FAQS = [
  {
    q: "Can you help with the actual songwriting, lyrics and melodies?",
    a: "Absolutely! That's one of the main things we'll be focusing on. I'm more of a partner \u201cin it\u201d with you vs. a producer just pushing buttons.",
  },
  {
    q: "How long does it usually take to finish a song?",
    a: "Typically 4 weeks. Give or take. I won't ever rush you but having momentum is important.",
  },
  {
    q: "Why shouldn't I just do this all myself?",
    a: "You 100% can! I will warn that wearing every hat can very easily lead to burnout and getting stuck. It can leave you with nothing to release or something you're not proud of (No bueno) I've gone through decades of this for you to lean on and take the \u201cguess-work\u201d out. Just focus on making tunes that actually hit a nerve and grow your audience.",
  },
  {
    q: "It's too expensive for me right now",
    a: "I totally get it, I'm glad you're thinking carefully about your investment. Here's the thing\u2014quality songwriting and releases are by far the MOST powerful tools you have. If the song isn't there, nothing else will work. Literally nothing else matters. Cutting corners WILL save you money. But from experience, I can promise it will limit how far you can really take things.",
  },
  {
    q: "What if my music isn't ready for this level of help?",
    a: "Your music is more ready than you think. I work with artists at all levels. Even if you're unsure about your sound, we figure it out together. I've taken 10 second voice memos and turned them into songs that now have millions of streams.",
  },
  {
    q: "What type of artists do you work with?",
    a: "Usually in the indie & pop sphere (a great song is a great song tho)",
  },
  {
    q: "How does the whole process work? I'm not sure where to begin.",
    a: "No worries! We start with a 1-on-1 call where I'll learn about your vision and vibe for the song. From there, I'll guide you through everything. From scratch songwriting and vocal ideas to final mixing and mastering. You'll never be wondering what's next.",
  },
  {
    q: "I'm feeling overwhelmed. Where do I even start?",
    a: "It's completely normal to feel that way, especially when you're juggling multiple things. From the first idea to the final track, I guide you through every step. We'll break it down so it feels manageable, and I'll make sure you stay focused on what matters. Making songs that move people.",
  },
];

export const INQUIRY_QUESTIONS = [
  {
    id: "holdup",
    type: "radio",
    label: "What's your biggest hold up right now?",
    options: [
      "Can't really finish anything",
      "Tired of working alone and losing momentum",
      "I'm putting out music but it's not growing",
    ],
    required: true,
  },
  {
    id: "timeframe",
    type: "radio",
    label: "How long have you had songs sitting around?",
    options: [
      "A few weeks",
      "A couple months",
      "A year or so",
      "Honestly, I've lost track",
    ],
    required: true,
  },
  {
    id: "musicLink",
    type: "url",
    label: "Where can I hear something?",
    helper: "Doesn't need to be released.",
    placeholder:
      "Spotify, Apple Music, SoundCloud, Google Drive, Dropbox, YouTube, etc.",
    required: true,
  },
  {
    id: "name",
    type: "text",
    label: "What's your name?",
    placeholder: "Your name",
    required: true,
  },
  {
    id: "email",
    type: "email",
    label: "What's your email?",
    placeholder: "you@email.com",
    required: true,
  },
  {
    id: "phone",
    type: "tel",
    label: "What's your cell number?",
    helper: "Optional, but helpful if email decides to play hide and seek.",
    placeholder: "(555) 123-4567",
    required: false,
  },
];

// Admin authentication is handled server-side via /api/admin/login.
// Client-side mock data has been removed.
